<template>
<div id="app-footer">
    <div class="footer-wrap">
        <div class="footer-menu-wrap">
            <ul>
                <!-- 코드 추가 - 2020-12-21 -->
                <li :key="index" v-for="(icon, index) in iconImgs" :class="file_name == icon.href ? 'icon-on' : 'icon-off'">
                    <!-- <router-link :to='icon.href'> -->
                    <div class="footer-menu" @click="linkClick(icon.href)">
                        <div class="icon-footer"><img :src="file_name == icon.href ? icon.on : icon.off"></div>
                        <span>{{icon.iconTxt}}</span>
                    </div>
                    <!-- </router-link>      -->
                    <!-- <a :href="icon.href">
                        <div class="footer-menu">
                            <div class="icon-footer"><img :src="file_name == icon.href ? icon.on : icon.off"></div>
                            <span>{{icon.iconTxt}}</span>
                        </div>
                    </a> -->
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import common from '../js/common';
import EventBus from '../js/event_bus';
export default {
    name: 'AppFooter',
    data() {
        return {
            file_name: '/',
            // iconImgs_nologin: [{
            //         on: require("../assets/images/bottomIcon01_on.png"),
            //         off: require("../assets/images/bottomIcon01.png"),
            //         iconTxt: '홈',
            //         href: '/home'
            //     },
            //     {
            //         on: require("../assets/images/bottomIcon02_on.png"),
            //         off: require("../assets/images/bottomIcon02.png"),
            //         iconTxt: '내주변',
            //         href: '/nearby'
            //     },
            //     {
            //         on: require("../assets/images/bottomIcon03_on.png"),
            //         off: require("../assets/images/bottomIcon03.png"),
            //         iconTxt: '지역',
            //         href: '/area'
            //     },
            //     {
            //         on: require("../assets/images/bottomIcon04_on.png"),
            //         off: require("../assets/images/bottomIcon04.png"),
            //         iconTxt: '역세권',
            //         href: '/station'
            //     }
            // ],
            iconImgs: [{
                    on: require("../assets/images/menu_01_over.png"),
                    off: require("../assets/images/menu_01.png"),
                    iconTxt: '홈',
                    href: '/'
                },
                {
                    on: require("../assets/images/menu_02_over.png"),
                    off: require("../assets/images/menu_02.png"),
                    iconTxt: '내 주변',
                    href: '/nearby'
                },
                {
                    on: require("../assets/images/menu_03_over.png"),
                    off: require("../assets/images/menu_03.png"),
                    iconTxt: '지역',
                    href: '/area'
                },
                {
                    on: require("../assets/images/menu_04_over.png"),
                    off: require("../assets/images/menu_04.png"),
                    iconTxt: '역세권',
                    href: '/station'
                },
                {
                    on: require("../assets/images/menu_05_over.png"),
                    off: require("../assets/images/menu_05.png"),
                    iconTxt: '내 매장',
                    href: '/mystore'
                }
            ],
            login_chk: false,
            // iconImgs:[]
        }
    },
    mounted() {
        this.$nextTick(function () {
            // this.iconImgs = this.imgs_login;
            if(this.$route.path !== '/detail'){
                this.file_name = this.$route.path;         
            }
        });
    },
    methods: {
        linkClick(e) {
            // this.file_name = e; 
            this.login_chk = this.$store.getters['getLogin_chk'].value;
            if (e == '/mystore') {
                if (!this.login_chk) {
                    if (this.$router.history.current.fullPath != '/mypage') {
                        this.$router.push('/login');
                    }
                } else {
                    if (this.$router.history.current.fullPath != '/mystore') {
                        this.$router.push('/mystore');
                    }
                }
            } else {
                if (e != this.$route.path) {
                    EventBus.$emit('search-init-data', e);
                    this.$router.push(e);
                }
            }
        }
    },
    watch: {
        $route(to, from) {
            if(to.path !== '/detail'){
                this.file_name = to.path;     
            }
            if (to.path === '/login') {
                this.file_name = '/mystore'
            }
            // 2021-01-14 코드수정 및 추가
            if(from.path == '/' && to.path !== '/nearby' && to.path !== '/area' && to.path !== '/station' && to.path !== '/login' && to.path !== '/mystore'){
                this.file_name = '/'
            }  
            
            // var path = to.path;
            // if (to.path === '/detail' || to.path === '/mypage') {
            //     path = from.path;
            // }
            // this.linkClick(path);

            // this.login_chk = this.$store.getters['getLogin_chk'].value;
            // if(this.login_chk){
            //     this.iconImgs = this.iconImgs_login;
            // }else{
            //     this.iconImgs = this.iconImgs_nologin;
            // }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue